export function downloadBlobToFile(blob, filename) {
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
        return;
    }
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const isMissing = (value) => value === null || value === undefined || value === '';

const toCsvValue = (value) => {
    if (value === undefined) return '';
    if (typeof value === 'string') return `"${value.replace(/"/g, '""')}"`;
    if (value !== null && typeof value === 'object') return toCsvValue(JSON.stringify(value));
    return String(value);
};

export default function CsvDownload(data, name, nullReplace) {
    const items = data;
    const filename = name || 'export.csv';

    const headerSet = new Set();
    items.forEach(row => Object.keys(row).forEach(key => headerSet.add(key)));
    const header = Array.from(headerSet);
    let csv = items.map(function (row) {
        return header.map(function (fieldName) {
            return toCsvValue(isMissing(row[fieldName]) ? nullReplace : row[fieldName]);
        }).join(',');
    });
    csv.unshift(header.join(','));
    csv = csv.join('\r\n');

    const blob = new Blob(['\uFEFF' + csv], {
        type: 'text/plain;charset=utf-8'
    });
    downloadBlobToFile(blob, filename);
};
